export default function languageSwitcher() {
    $('.language-switcher__lang-current').on('click', e => {
        $('.footer-top-menu__submenu').removeClass('active');
        $('.footer-top-menu__arrow').removeClass('active');
        const clickedLangSwitcher = $(e.currentTarget);
        clickedLangSwitcher.find('.icon').toggleClass('active');
        clickedLangSwitcher.next().toggleClass('active');
    });
}
